module.exports = __webpack_public_path__ + "img/5_1.72315eaf.jpg";